import { useEffect, useState } from "react"
import { useAppCtx } from "lib/state"
import { queryTools, cookie } from "lib/utils"


export default function useAuth(appState:any){

  const [ authCookie, setAuthCookie ] = useState<any>(null)

  const { data:user } = queryTools.resource.parseQueryForApi("user.findById", { _id: authCookie }, { enabled: !!authCookie })

  useEffect(() => {
    console.log(authCookie)
    console.log(user)
    // if( user ) appTools.updateState("user", user)
  },[user])

  useEffect(() => {
    if( !window.location.href.includes("login") ){
      const authCookieFound = cookie.get("mm-app-user")
      if (!authCookieFound){
        // window.location.href = "/login"
      } else {
        setAuthCookie(authCookieFound)
      }
    }
  },[window.location.href])

  return {
    user
  }

}